/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="controls.module.ts" />

module Meevo.Components.Controls {
    class MultiLocationController {

        static $inject = ["context", "$filter", "$mdDialog"]
        public context: any;
        protected loadedList: any;
        constructor(context: any, protected $filter: angular.IFilterService, private $mdDialog: angular.material.IDialogService) {
            this.context = context;
            this.loadedList = context.selectedSection.model.locationOverride.locations.slice();
        }

        apply = (arr: any) => {
            this.context.selectedSection.model.locationOverride.locations = arr;
            this.$mdDialog.hide();
        }

        cancel = () => {
            this.context.selectedSection.model.locationOverride.locations = this.loadedList;
            this.$mdDialog.hide();
        }
    }

    angular.module("meevo.components.controls")
      .controller("meevo.components.controls.MultiLocationController", MultiLocationController);
}